module.exports = __webpack_public_path__ + "static/nastuh-abootalebi-284884-unsplash-2578f4df377be341c34c6d97dee1e5e0.jpg";